import { createSlice } from "@reduxjs/toolkit";

type ViewDataPageState = {
  object: {
    viewType?: string;
    key?: string;
    data?: any;
  };
};

const initialState: ViewDataPageState = { object: null };

const viewDataPageSlice = createSlice({
  name: "viewDataPage",
  initialState: initialState,
  reducers: {
    addViewObject: (state, action) => {
      const { key, data, viewType } = action.payload;
      state.object = { viewType, key, data };
    },
    removeObject: (state) => {
      state.object = null;
    },
  },
});

export const { addViewObject, removeObject } = viewDataPageSlice.actions;

export default viewDataPageSlice.reducer;
